import React from "react";
import logo from "../../images/Logo.png";
import { withRouter } from "react-router-dom";

const styles = {
  topBar: {
    backgroundColor: "darkgrey",
    width: "100vw",
    maxWidth: "100%",
    height: "max-content",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  logo: { width: "600px", maxWidth: "100%", height: "auto" },
};

const TopBar = ({ history, setExpanded, setBgColor }) => {
  const onLogoClick = () => {
    setExpanded(false);
    setBgColor("#575757");
    history.push("/");
  };
  return (
    <div style={styles.topBar} onClick={onLogoClick}>
      <img src={logo} style={styles.logo} alt="logo" />
    </div>
  );
};

export default withRouter(TopBar);
